import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { SelAgesEditorComponent } from './sel-ages-editor.component';
import { ButtonModule } from 'src/app/shared/form/button/button.module';
import { SelectModule } from 'src/app/shared/form/select/select.module';
import { TextfieldComponent } from 'src/app/shared/form/textfield/textfield.component';
import { ColorPickerModule } from 'src/app/shared/form/color-picker/color-picker.module';
import { ContentPickerModule } from 'src/app/shared/form/content-picker/content-picker.module';
import { AssociatedUnitsListComponent } from 'src/app/shared/associated-units-list/associated-units-list.component';

@NgModule({
  declarations: [SelAgesEditorComponent],
  imports: [
    FormsModule,
    SharedModule,
    CommonModule,
    RouterModule,
    SelectModule,
    ButtonModule,
    TextfieldComponent,
    ColorPickerModule,
    ContentPickerModule,
    AssociatedUnitsListComponent,
  ],
})
export class SelAgesEditorModule {}
